import { lazy } from "react";
import { RouteConfig } from "../../../types/RouteConfig";

export const planToRenew: RouteConfig<'with-page'> = {
    name: 'Plan to Renew',
    path: '/myaccount/plan-to-renew',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route','no-menu-item'],
}